import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { AddNameTuneAPI } from '../api/nametune/addnametuneapi';
import { AddNameTuneRequest } from '../api/nametune/addnametunerequest';
import { AddNameTuneResponse } from '../api/nametune/addnametuneresponse';
import { AddNameTuneAPIProcessorImpl } from '../processor/addnametuneapiprocessor';
import { APIProcessor } from '../processor/apiProcessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { AddNameTuneNonLoggedInUserAPI } from '../api/nametune/addnametunenonloggedinuserapi';
import { AddNameTuneNonLoggedInUserAPIProcessorImpl } from '../processor/addnametunenonloggedinuserapiprocessor';

export class NameTuneProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(NameTuneProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getAddNameTuneAPIProcessor():APIProcessor<AddNameTuneRequest, AddNameTuneResponse>
    {
        this.logger.log("getAddNameTuneAPIProcessor() invoked");
        return new AddNameTuneAPIProcessorImpl(this.getContext(), new AddNameTuneAPI(this.getHttpClient(), this.getContext()));
    }

    getAddNameTuneNonLoggedInAPIProcessor():APIProcessor<AddNameTuneRequest, AddNameTuneResponse>
    {
        this.logger.log("getAddNameTuneAPIProcessor() invoked");
        return new AddNameTuneNonLoggedInUserAPIProcessorImpl(this.getContext(), new AddNameTuneNonLoggedInUserAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/nametuneprocessorfactory.tsx